import { render, staticRenderFns } from "./CustomPDFViewer.vue?vue&type=template&id=91f283a2&"
import script from "./CustomPDFViewer.vue?vue&type=script&lang=ts&"
export * from "./CustomPDFViewer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports